import { Card, CardBody, Col } from "reactstrap";
import { LI, UL } from "../../../AbstractElements";
import { DefaultListTitle, ECommerce, LogoDesign, SEO, WebDesignDevelop } from "../../../Constants/Constants";
import { DefaultListSubTitle } from "../../../Data/UiKits/Lists";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const DefaultList = () => {
  return (
    <Col xl="4" md="6">
      <Card>
        <CommonCardHeader title={DefaultListTitle} span={DefaultListSubTitle} />
        <CardBody>
          <UL>
            <LI><i className="icofont icofont-arrow-right" />{LogoDesign}</LI>
            <LI><i className="icofont icofont-arrow-right" />{WebDesignDevelop}</LI>
            <LI><i className="icofont icofont-arrow-right" />{ECommerce}</LI>
            <LI><i className="icofont icofont-arrow-right" />{SEO}</LI>
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};
export default DefaultList